<template>
  <MarketCard class="promo">
    <CardHeader :eventId="eventId" />
    <div :class="classes.content">
      <div :class="classes.leftContent">
        <EventNameFitted
          :class="[classes.eventName, 'event-name']"
          :eventId="eventId"
          alignment="flex-start"
        />

        <div :class="[classes.promoWrapper]">
          <promo-fitted-text
            :promoText="promoText"
            alignment="flex-start"
          ></promo-fitted-text>
        </div>
      </div>

      <div :class="classes.rightContent">
        <div :class="classes.logoWrapper">
          <PromoLogo
            :class="classes.promoLogo"
            :promoMarketName="marketData.promoMarketName"
            :marketName="marketData.marketName"
          />
        </div>

        <div :class="classes.oddsButtonWrapper">
          <Button
            :class="[classes.oddsButton]"
            :marketId="marketId"
            :option="option"
          />
        </div>
      </div>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import MarketCard from "../../styled/MarketCard.vue";
import CardHeader from "../../CardHeader.vue";
import EventNameFitted from "../../EventNameFitted.vue";
import Button from "./Button.vue";
import PromoLogo from "./Logo.vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import {
  composeMarket,
  injectBetData
} from "@fresh8/ad-data-composition/src/betData";
import PromoFittedText from "../../PromoFittedText.vue";

const { useStyles } = createUseStyles(
  {
    content: {
      display: "flex",
      flex: 1
    },
    leftContent: {
      flex: 1,
      padding: "6px 0 6px 6px",
      display: "flex",
      flexDirection: "column"
    },
    rightContent: {
      flex: "0 2 20%",
      display: "flex",
      flexDirection: "column",
      padding: "6px",
      minWidth: "95px"
    },
    eventName: {
      textAlign: "left",
      fontSize: "13px",
      boxSizing: "border-box",
      display: "flex",
      "&.event-name > div, &.event-name": {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left"
      }
    },
    promoWrapper: {
      flex: "1 1 0",
      minHeight: "0px",
      overflow: "hidden",
      boxSizing: "border-box",
      flexDirection: "column",
      display: "flex"
    },
    logoWrapper: {
      display: "flex",
      marginBottom: "4px"
    },
    oddsButtonWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1
    },
    promoLogo: {
      width: "100%",
      maxHeight: "20px",
      "&.promo-market-name": {
        fontSize: "12px !important"
      }
    },
    oddsButton: {
      height: "100%",
      maxHeight: "55px",
      "& .odds-text": {
        fontSize: "14px"
      }
    },
    resize: {
      pointerEvents: "none",
      zIndex: -99
    }
  },
  undefined
);

export default defineComponent({
  name: "PromoCard",
  components: {
    MarketCard,
    CardHeader,
    EventNameFitted,
    Button,
    PromoLogo,
    PromoFittedText
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { classesRef } = useStyles(ref(undefined));
    const { options } = injectBetData();
    const marketData = composeMarket(props.marketId);

    const option = computed(
      () => marketData.value && options.value?.[marketData.value.options[0]]
    );

    return {
      promoText: computed(() => option.value.promoText),
      classes: classesRef,
      marketData,
      option
    };
  }
});
</script>
